module.exports = __webpack_public_path__ + "img/ic-line.f438f84f.svg";